<template>
  <div
    :id="id"
    data-toggle="tooltip"
    :data-placement="placement"
    :data-original-title="title"
    style="display: inline"
  >
    <slot></slot>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    placement: {
      type: String,
      default: 'bottom',
      validator: (pos) => ['top', 'bottom', 'right', 'left', 'auto'].includes(pos)
    },
    content: {
      type: String,
      default: ''
    },
    contentHTML: {
      type: String,
      default: ''
    },
    selector: {
      type: String,
      default: 'body'
    },
    isDark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!this.disabled) {
      $(`#${this.id}`).tooltip({
        template: this.template,
        animation: false,
        html: Boolean(this.isContentHTML),
        viewport: this.viewport,
        trigger: 'hover'
      });
    }
  },
  watch: {
    disabled() {
      if (!this.disabled) {
        $(`#${this.id}`).tooltip({
          template: this.template,
          animation: false,
          html: Boolean(this.isContentHTML),
          viewport: this.viewport,
          trigger: 'hover'
        });
      }
    }
  },
  computed: {
    id() {
      return `tooltip${Math.floor(Math.random() * 100000)}`;
    },
    isContentHTML() {
      return this.contentHTML !== '';
    },
    title() {
      return this.isContentHTML ? this.contentHTML : this.content;
    },
    viewport() {
      return {
        selector: this.selector,
        padding: this.selector === 'body' ? 0 : 25
      };
    },
    template() {
      return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner ${
        this.isDark ? 'dark' : ''
      }"></div></div>`;
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin border-properties {
  border: none;
  box-shadow: none;
  outline: none;
}
.tooltip {
  &.top {
    .tooltip-arrow {
      @include border-properties();
    }
  }
}
.tooltip-inner {
  @include border-properties();
}
</style>
